<template>
    <header class="header" @mouseleave="activeAccess = false">
        <div class="header-wrapper">
            <div class="header-wrapper-logo" @mouseenter="activeAccess = false">
                <router-link to="/">
                    <!-- <img v-if="mobileMenu | timeline" src="@/assets/png/logo_white.png"> -->
                    <img v-if="!(mobileMenu | timeline)" src="@/assets/logo.jpg" width="50px" height="50px">
                </router-link>
            </div>
            <div class="header-wrapper-content">
                <div class="header-wrapper-content-requisites" @mouseenter="activeAccess = false">
                    <div class="header-wrapper-content-requisites-item">
                        <img src="@/assets/svg/marker.svg">
                        <span class="header-wrapper-content-requisites-item-a">1 Club Road, Golden Gate, Regimanuel Gray Estate, East Airport, Accra</span>
                    </div>
                    <div class="header-wrapper-content-requisites-item">
                        <img :class="{imageWhite: mobileMenu}" src="@/assets/svg/phone.svg">
                        <a class="header-wrapper-content-requisites-item-a" :class="{activeMenu: mobileMenu}" href="tel:+2330302811740">+233 050 145 3030 </a>
                    </div>
                    <div class="header-wrapper-content-requisites-item">
                        <a target="_blank" class="header-wrapper-content-requisites-item-link" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@rgeahosa.org"><img :class="{imageWhite: mobileMenu}" src="@/assets/svg/mail.svg"></a>
                        <a target="_blank" class="header-wrapper-content-requisites-item-a" :class="{activeMenu: mobileMenu}"  href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@rgeahosa.org">info@rgeahosa.org </a>
                    </div>
                </div>
                <nav class="header-wrapper-content-nav">
                    <div class="header-wrapper-content-nav-item" @mouseenter="activeAccess = false">
                        <router-link class="header-wrapper-content-nav-item-a" to="/" exact><span>Home</span></router-link>
                    </div>
                    <div class="header-wrapper-content-nav-item" v-if="!isAuthorized" @mouseenter="activeAccess = true">
                        <router-link class="header-wrapper-content-nav-item-a" to="/login"><span>Member Access</span></router-link>
                    </div>
                    <div class="header-wrapper-content-nav-access-menu header-wrapper-content-nav-user-menu" v-if="activeAccess">
                        <router-link class="header-wrapper-content-nav-user-menu-a" to="/login">Login</router-link> 
                        <router-link class="header-wrapper-content-nav-user-menu-a" to="/register">Registration</router-link> 
                    </div>
<!--                    <div class="header-wrapper-content-nav-item" v-if="!isAuthorized">-->
<!--                        <router-link class="header-wrapper-content-nav-item-a" to="/about-us"><span>About Us</span></router-link>-->
<!--                    </div>-->
                    <div class="header-wrapper-content-nav-item" v-if="isAuthorized">
                        <router-link class="header-wrapper-content-nav-item-a" to="/library"><span>Documents</span></router-link>
                    </div>
                    <div class="header-wrapper-content-nav-item" v-if="isAuthorized">
                        <router-link class="header-wrapper-content-nav-item-a" to="/events"><span>Events</span></router-link>
                    </div>
                    <div class="header-wrapper-content-nav-item" v-if="isAuthorized">
                        <router-link class="header-wrapper-content-nav-item-a" to="/gallery"><span>Gallery</span></router-link>
                    </div>
                    <div class="header-wrapper-content-nav-item" v-if="isAuthorized">
                        <router-link class="header-wrapper-content-nav-item-a" to="/council"><span>Council Members</span></router-link>
                    </div>
                    
                    <div class="header-wrapper-content-nav-item" @mouseenter="activeAccess = false">
                        <router-link class="header-wrapper-content-nav-item-a" to="/contacts"><span>Contact Us</span></router-link>
                    </div>
                    <app-gamburger @click="openMenu" @gamburger="gamburger = false" :active="gamburger"></app-gamburger>
                    <app-mobile-menu :isAuthorized="isAuthorized" :class="{active: mobileMenu }" :activeLink="activeLink" @closeMenu="mobileMenu = !mobileMenu; activeLink = !activeLink; gamburger = !gamburger"></app-mobile-menu>
                    <div v-if="isAuthorized" class="header-wrapper-content-nav-block"></div>
                    <div class="header-wrapper-content-nav-user" @click="activeUserMenu = !activeUserMenu">
                        <img v-if="isAuthorized" src="@/assets/svg/man-ico.svg">
                        <span v-if="isAuthorized">{{firstname}}</span>
                        <div class="header-wrapper-content-nav-user-menu" v-if="activeUserMenu">
                            <router-link class="header-wrapper-content-nav-user-menu-a" to="/account" v-if="isAuthorized">Account</router-link>
                            <button v-if="isAuthorized" class="header-wrapper-content-nav-user-menu-btn" @click="logout()">Log Out</button>
                        </div>
                    </div>
                    <div v-if="!isAuthorized" class="header-wrapper-content-nav-block p480" :class="{blockWhite: mobileMenu}"></div>
                    <div v-if="!isAuthorized" class="header-wrapper-content-nav-user p480">
                        <img :class="{imageWhite: mobileMenu}" src="@/assets/svg/man-ico.svg">
                        <span>{{ firstname }} </span>
                    </div>
                    <!-- <div v-if="!isAuthorized" class="group">
                        <div class="header-wrapper-content-nav-login">
                            <router-link to="/login">
                                <span>Login</span>
                            </router-link>
                        </div>
                        <div class="header-wrapper-content-nav-block"></div>
                        <div class="header-wrapper-content-nav-registration">
                            <router-link to="/register">
                                <span>Registration</span>
                            </router-link>
                        </div>
                    </div> -->
                </nav>
            </div>
        </div>
    </header>
</template>
<script>
import Gamburger from "@/components/ui/Gamburger";
import MobileMenu from "@/components/ui/MobileMenu";
import UserServices from "../../services/UserServices";
import { setTimeout } from 'timers';
    export default {
        data(){
            return {
                isAuthorized: false,
                mobileMenu: false,
                activeLink: false,
                activeCabinet: false,
                gamburger: false,
                timeline: false,
                activeUserMenu: false,
                firstname: '',
                activeAccess: false,

                user:{
                    name:'',
                    lastname:'',
                    email:'',
                }
            }
        },
        created() {
            this.firstname = localStorage.getItem('firstname')
        },
        methods: {
            openMenu() {
                if (this.mobileMenu) {
                    document.body.removeAttribute("style");
                } else {
                    //document.body.style.overflow = "hidden";
                }
                this.mobileMenu = !this.mobileMenu;
                this.timeline = true
                if(this.mobileMenu == false) {
                    setTimeout (()=>{ this.timeline = false}, 250)
                }
                this.activeLink = !this.activeLink;
            },
            async logoutUser(){
                try {
                    const resp = await UserServices.logout();
                    return resp;
                }
                catch (e) {
                    return e;
                }
            },
            logout() {
                this.logoutUser().then((resp)=>{ 
                    console.log(resp)
                    localStorage.removeItem('token')
                    localStorage.removeItem('firstname')
                    location.reload(true)                   
                })
            }
        },
        mounted(){
           if(localStorage.getItem('token') != null){
               this.isAuthorized = true;
           }
        },
        components: {
            "app-gamburger": Gamburger,
            "app-mobile-menu": MobileMenu,
        }
    }
</script>
<style lang="scss" scoped>
    .p480 {
        display: none !important;
        @media screen and (max-width: 480px) {
            display: flex !important;
        }
    }
    .group {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        @media screen and (max-width: 480px) {
            display: none;
        }
    }
    .header {
        width: 100%;
        box-shadow: 6px 10px 32px rgba(0, 0, 0, 0.05);
        &-wrapper {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            max-width: 1180px;
            margin-right: auto;
            margin-left: auto;
            width: 100%;
            position: relative;
            z-index: 9999;
            &-logo {
                width: 25%;
                margin-top: 20px;
                margin-right: 5px;
                min-width: 59px;
                height: 92px;
                margin-bottom: 13px;
                position:relative;
                z-index: 99999;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width:100%;
                }
            }
            &-content {
                display: flex;
                flex-direction: column;
                width: 85%;

                &-requisites {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    padding-bottom: 14px;
                    border-bottom: 1px solid #e8e8e8;
                    position: relative;
                    z-index:99999;
                    margin-bottom: 32px;
                    &-item {
                        display: flex;
                        align-items: center;
                        &-link {
                            height:13px;
                        }
                        img {
                            width: 11px;
                            height: 15px;
                            margin-right: 9px;
                            fill: #1a924a;
                            @media screen and (max-width: 720px) {
                                margin-right: 5px;
                            }
                            @media screen and (max-width: 480px) {
                                margin-right: 8px;
                            }
                        }
                        @media screen and (max-width: 480px) {
                            &:first-child {
                                display: none;
                            }
                        }
                        @media screen and (max-width: 720px) {
                            &:first-child {
                                width: 182px;
                            }
                        }
                        &-a {
                            text-decoration: none;
                            margin-top: 1px;
                            color: #9b9b9b;
                            font-family: "Open Sans";
                            font-size: 12px;
                            font-weight: 400;
                            letter-spacing: 0.3px;
                            //white-space: nowrap;
                            @media screen and (max-width: 720px) {
                                white-space: nowrap; /* Отменяем перенос текста */
                                overflow: hidden; /* Обрезаем содержимое */
                                text-overflow: ellipsis; /* Многоточие */
                                font-size: 9px;
                            }
                            @media screen and (max-width: 480px) {
                                font-size: 10px;
                            }
                        }
                    }
                }
                &-nav {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    a {
                        text-decoration: none;
                    }
                    &-login {
                        span {
                            color: #1a924a;
                            font-family: "Open Sans";
                            font-size: 14px;
                            font-weight: 400;
                            letter-spacing: 0.35px;
                            cursor: pointer;
                        }
                        @media screen and (max-width: 720px) {
                            span {
                                font-size: 10px;
                            }
                        }
                    }
                    &-registration {
                        span {
                            color: #1a924a;
                            font-family: "Open Sans";
                            font-size: 14px;
                            font-weight: 400;
                            letter-spacing: 0.35px;
                            cursor: pointer;
                        }
                        @media screen and (max-width: 720px) {
                            span {
                                font-size: 10px;
                            }
                        }
                    }
                    &-access-menu {
                        position:absolute;
                        right:40% !important;
                        top:120px !important;
                    }
                    &-user {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        position:relative;
                        &-menu {
                            background-color:#1a924a;
                            position:absolute;
                            right:0;
                            top:40px;
                            display: flex;
                            flex-direction: column;
                            min-width:198px;
                            padding:16px 12px;
                            &-btn {
                                outline:none;
                                border:none;
                                background-color:transparent;
                                color: white;
                                font-family: "Open Sans";
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 36px;
                                letter-spacing: 0.35px;
                                padding: 21px;
                                text-align:left;
                                cursor:pointer;
                            }
                            &-a {
                                color: white;
                                font-family: "Open Sans";
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 36px;
                                letter-spacing: 0.35px;
                                padding: 21px;
                                border-bottom: 1px solid #e8e8e8;
                            }
                        }
                        img {
                            width: 16px;
                            height: 20px;
                            margin-right: 15px;
                        }
                        span {
                            color: #1a924a;
                            font-family: "Open Sans";
                            font-size: 14px;
                            font-weight: 400;
                            text-decoration: underline;
                            letter-spacing: 0.35px;
                            @media screen and (max-width: 720px) {
                                display: none;
                            }
                        }
                        @media screen and (max-width: 480px) {
                            display: flex;
                            position: absolute;
                            right: 20px;
                            margin-top:1px;
                        }
                    }
                    &-block {
                         height: 22px;
                         border-left: 1px solid #d1d1d1;
                        margin-right: 15px;
                        margin-left: 15px;
                        @media screen and (max-width: 720px) {
                            margin-right: 5px;
                            margin-left: 5px;
                        }
                        @media screen and (max-width: 480px) {
                            position: absolute;
                            right: 80px;
                        }
                    }
                    &-item {
                        position:relative;
                        @media screen and (max-width: 480px) {
                            display: none;
                        }
                        &-block {
                            width: 100%;
                            height: 5px;
                            background-color: #2a9854;
                            margin-top: 8px;
                            display: none;
                        }
                       &-a {
                            text-decoration: none;
                            color: #38383a;
                            font-family: "Open Sans";
                            font-size: 14px;
                            font-weight: 400;
                            letter-spacing: 0.35px;
                            padding-bottom: 5px;
                           @media screen and (max-width: 720px) {
                               font-size: 10px;
                           }
                        }
                    }
                }
            }
        }
    }
    .activeMenu {
        color:white !important;
    }
    .imageWhite {
        filter: brightness(100);
        z-index: 9999;
    }
    .blockWhite {
        border-left-color: white !important;
        z-index: 9999;
    }
a.router-link-active, li.router-link-active>a {
    span {
        border-bottom: 4px solid #1a924a;
    }
}
</style>
